import { render, staticRenderFns } from "./DocumentListRb.vue?vue&type=template&id=60867190&scoped=true&"
import script from "./DocumentListRb.vue?vue&type=script&lang=js&"
export * from "./DocumentListRb.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListRb.vue?vue&type=style&index=0&id=60867190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60867190",
  null
  
)

export default component.exports